import { FC } from 'react';
import { GenericLink, LoaderType, NextgenImage } from '@nextgen-web-framework/all';
import type { QuickLinkDesignOneProps } from './types/propsTypes';
import styles from './QuickLinkDesignOne.module.scss';

const QuickLinkDesignOne: FC<QuickLinkDesignOneProps> = ({ quickLinks }) => (
  <div className={styles['quick-link-design-one-container']} data-testid={'quick-link-design-one-test-id'}>
    {quickLinks?.map((data) => (
      <div
        key={`${data.title}${data.linkdata}`}
        className={styles['quick-link-design-container']}
        data-testid={'quick-link-design-container-test-id'}
      >
        <div className={styles['quick-link-design-left-wrapper']}>
          <div className={styles['quick-link-design-image-wrapper']}>
            <NextgenImage
              className={styles['quick-link-image-item']}
              src={data.imagedata.url}
              alt="quickLinkImageAltText"
              loaderType={LoaderType.CONTENTSTACK}
            />
          </div>
        </div>
        <div className={styles['quick-link-design-right-wrapper']}>
          <div className={styles['quick-link-design-text']}>{data.title}</div>
          <div className={styles['quick-link-design-url']}>
            <GenericLink href={data.linkdata.url} forceNative={false} target={data.linkdata.target}>
              {data.linkdata.text}
            </GenericLink>
          </div>
        </div>
      </div>
    ))}
  </div>
);

export default QuickLinkDesignOne;
export type { QuickLinkDesignOneProps };
